import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { onMfaEnrollmentRequired } from './api/client';
import { ApiError } from './api/errors';
import { router } from './app/router';
import { AuthProvider } from './auth/AuthProvider';
import './styles.css';
import { ToastProvider } from './ui/ui';
import { installNoAutofill } from './lib/no-autofill';
import { installSpanishValidity } from './lib/validity';

installSpanishValidity();
installNoAutofill();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      // No reintentar errores de cliente (4xx): no se van a arreglar solos.
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
    },
  },
});

// La empresa exige verificación en dos pasos y el usuario no la tiene: se lleva a activarla.
const MFA_PAGE = '/settings/security';
onMfaEnrollmentRequired(() => {
  if (window.location.pathname !== MFA_PAGE) void router.navigate(`${MFA_PAGE}?mfa=required`);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
